export const VERIFICATION_COMMANDER = `
# Verification: Commander

- Require evidence for every completed task: file reads, command output, tests, or direct runtime observation.
- Ask Reviewer for final integration verification before declaring the mission complete.
- Keep unresolved failures visible in the mission summary with owner, cause, and next step.
`;
